import api from "../lib/api";


export const createObjection = (payload: any) =>
  api.post("/api/objection/create-objection", payload);

export const editObjection = (payload: any) =>{
  let {_id , ...rest} = payload;
 return api.post(`/api/objection/edit-objection?id=${_id}`, rest);}

export const deleteObjection = (id: string)=> api.post(`/api/objection/delete/${id}`)

export const actionObjection = (id: string, data: any)=> {
  return api.post(`/api/objection/action-objections/${id}`, data)
}
